<template>
  <div
    v-show="order.transactions.length"
    :class="$style.base"
  >
    <Flex
      direction="column"
      :class="$style.transactions"
    >
      <TransitionGroup name="list">
        <Transaction
          v-for="(transaction, index) in transactions"
          :key="transaction._uid || index"
          :transaction="transaction"
          :class="[$style.transaction, { [$style.editable]: editable }]"
          v-bind="{ editable }"
        />
      </TransitionGroup>
    </Flex>

    <div
      v-if="transactions.length > 1"
      :class="$style.total"
    >
      <BaseHeading size="s">{{ $t('global.paid') }}</BaseHeading>
      <BaseText v-test="'register-transactions-total'">
        {{ filters.currency(totalPaid) }}
      </BaseText>
    </div>
    <div
      v-if="outstandingAmount < 0"
      :class="$style.change"
    >
      <BaseHeading size="s">{{ $t('register.change_money') }}</BaseHeading>
      <BaseText v-test="'register-transactions-change'">
        {{ filters.currency(Math.abs(outstandingAmount)) }}
      </BaseText>
    </div>
  </div>
</template>

<script
  setup
  lang="ts"
>
import { storeToRefs } from 'pinia';
import filters from '@/filters';
import { useRegisterOrderStore } from '@/modules/register/stores/order';
import Transaction from './Transaction.vue';

defineProps<{
  editable?: boolean;
}>();

const { order } = useRegisterOrderStore();
const {
  totalPaid,
  outstandingAmount,
  activeTransactions: transactions,
} = storeToRefs(useRegisterOrderStore());
</script>

<style
  lang="scss"
  module
>
.base {
  border-top: 1px solid var(--color-border);
}

.transactions {
  position: relative; // Needed for the transition of the child elements, which sets position: absolute;
  padding: $spacing * 0.5 0 $spacing * 0.5 $spacing;
}

.transaction {
  &.editable {
    padding-right: 0;
  }

  &:not(.editable) {
    padding-right: $spacing;
  }
}

.total {
  display: flex;
  justify-content: space-between;
  padding: $spacing;
  background-color: var(--color-bg-secondary);
}

.change {
  display: flex;
  justify-content: space-between;
  padding: $spacing;
  border-top: 1px solid var(--color-border);
}

.transaction {
  transition: background-color 0.5s ease;
}
</style>

<style
  lang="scss"
  scoped
>
.list-enter-to {
  background-color: rgb(3, 207, 165, 0.3);
}

.list-move,
.list-leave-active {
  transition:
    opacity 0.2s ease,
    transform 0.2s ease;
}

.list-leave-to {
  opacity: 0;
}

.list-leave-active {
  position: absolute;
  width: 100%;
}
</style>
